import React, { useState, useCallback, useEffect, useContext } from 'react';
import { Popover, Button } from '@superops/ui-design-system';
import styled from 'styled-components';
import {
  DeleteModal,
  MilestoneModal
} from '@nile/projects/src/Components/Modals';
import { useMutation } from '@apollo/client';
import {
  DELETE_PROJECT,
  GET_PROJECT,
  SOFT_DELETE_PROJECTS,
  RESTORE_PROJECTS
} from '@nile/projects/src/Graphql';
import { withRouter } from 'react-router-dom';
import TabContext from '@nile/mangifera/src/Contexts/TicketContext';
import { useQuery } from '@apollo/client';
import { AccountClient } from '@nile/graphql';
import { GET_ALL_EMPLOYEES } from '@nile/banyan/src/Graphql/Mutations/employee';
import { EmployeesPicker } from '@nile/projects/src/Components/Inputs';
import ProjectContext from '@nile/projects/src/Contexts/ProjectContext';
import {
  TicketClient,
  CREATE_MILESTONE_TASK,
  GET_TECHNICIANS_BY_CRITERIA,
  CREATE_TASKS
} from '@nile/graphql';
import {
  constructTaskObject,
  isUnauthorizedUserPresent,
  filterAttrs,
  excludeMembers
} from '@nile/projects/src/Utils';
import { cloneDeep } from 'lodash';
import {
  NewTask,
  CopyTask,
  NormalModal,
  getTranslatedText,
  AccessControl,
  BackgroundIcon,
  toast,
  ERROR_CODES,
  actionToast,
  ALL_MODULES,
  useActivityTracker,
  useProduct
} from '@nile/components';
import envConfig from '@nile/home/src/Config/env';
import { FormattedMessage, injectIntl } from 'react-intl';
import { SVGIcon } from '@superops/super-icons';
import { getTechnicianVariables } from '@nile/graphql/src/Constants/variablesResolver';
import { useCheckIsItProduct } from '@nile/components/src/Utils/helpers';

const Field = styled.div`
  min-width: 150px;
  max-width: 250px;
  flex-grow: 1;
  margin-top: 8px;
  margin-bottom: 8px;
  display: flex;
  flex-direction: column;
  align-items: flex-start;
  .Superops-ButtonGroup {
    margin-top: 12px;
  }
  .memberCount {
    font-weight: normal;
  }
  .opt {
    color: black;
    justify-content: flex-start;
    .Superops-Button.Superops-Button--plain {
      padding: 0 10px !important;
      margin: -5px 0;
      justify-content: flex-start;
      // color: inherit;
      &.Superops-Button--destructive {
        color: var(--p-action-critical, #bf0711);
      }
    }
    :hover {
      background-color: #0000000d;
    }
  }
`;

const ActionsBtn = (props) => {
  const { intl, site, client } = props;
  const currentProduct = useProduct();

  const tabContext = useContext(TabContext);

  const [active, setActive] = useState(false);

  const [warningModal, setWarningModal] = useState(false);

  const [taskTemplates, setTaskTemplates] = useState([]);

  const handleChange = useCallback(() => setActive(!active), [active]);

  const [popoverActive, setPopoverActive] = useState(false);

  const [delModalActive, setDelModalActive] = useState(false);

  const [sheetActive, setSheetActive] = useState(false);

  const projectContext = useContext(ProjectContext);

  const isItProduct = useCheckIsItProduct();

  const toggleSheetActive = () => {
    setSheetActive(!sheetActive);
  };

  const handleDelModalChange = useCallback(
    () => setDelModalActive(!delModalActive),
    [delModalActive]
  );

  const presentMembers = props.members.map((member) => member.user.userId);
  presentMembers.push(props.owner.userId);

  const [softDeleteProject] = useMutation(SOFT_DELETE_PROJECTS, {
    onCompleted({ softDeleteProjects }) {
      if (softDeleteProjects) {
        // toast('success', 'toast.projects.trash.success');
      }
    }
  });

  const [restoreProjects] = useMutation(RESTORE_PROJECTS, {
    onCompleted({ restoreProjects }) {
      if (restoreProjects) {
        toast('success', 'toast.projects.restore.success');
      }
    }
  });

  const handleRestore = (id) => {
    restoreProjects({ variables: { ids: [id] } });
  };

  const addTaskTemplatesHandler = (updatedTaskList) => {
    if (updatedTaskList?.length) {
      TicketClient.mutate({
        mutation: CREATE_TASKS,
        variables: { taskInput: updatedTaskList }
      })
        .then((res) => {
          if (res?.data?.createTasks) {
            toast('success', 'Tasks added successfully');
            TicketClient.query({
              query: GET_PROJECT,
              variables: { projectId: props.projectId, isItProduct },
              fetchPolicy: 'network-only'
            }).then((resp) => {
              if (resp?.data?.getProject) {
                props.setProject(resp.data.getProject);
                setTaskTemplates([]);
                setWarningModal(false);
              }
            });
          }
        })
        .catch((err) => {
          // if (
          //   err?.graphQLErrors?.[0]?.extensions?.clientError?.[0]?.errorCode
          // ) {
          //   toast(
          //     'error',
          //     <FormattedMessage
          //       id={
          //         ERROR_CODES[
          //           err.graphQLErrors[0].extensions.clientError[0].errorCode
          //         ]
          //       }
          //     />
          //   );
          // } else {
          //   // toast('error', 'Something went wrong');
          // }
        });
    }
  };

  const updateContext = (type, taskList) => {
    if (type === 'taskTemplateList') {
      let updatedTaskList = taskList.map((task) => {
        const { taskTemplateId, ...rest } = task;
        rest.project = {
          projectId: props.projectId
        };
        rest.technician = filterAttrs(rest.technician);
        return rest;
      });
      if (isUnauthorizedUserPresent(presentMembers, updatedTaskList)) {
        updatedTaskList = excludeMembers(presentMembers, updatedTaskList);
        setTaskTemplates(updatedTaskList);
        setWarningModal(true);
      } else {
        addTaskTemplatesHandler(updatedTaskList);
        setTaskTemplates(updatedTaskList);
      }
    }
  };

  const context = {
    value: {
      addTaskTemplateList: [],
      removeTaskTemplateList: [],
      taskTemplateList: [],
      selectedTaskTemplates: []
    },
    updateContext: updateContext
  };

  const milestoneModal = React.createRef();
  const delModal = React.createRef();

  const [clientEmployees, setClientEmployees] = useState([]);

  useEffect(() => {
    if (props?.client?.accountId || props?.site?.id) {
      AccountClient.query({
        query: GET_TECHNICIANS_BY_CRITERIA,
        variables: getTechnicianVariables({
          clientIds: [client?.accountId],
          siteIds: [site?.id],
          currentProduct,
          isListInfoRequired: true
        })
      }).then((res) => {
        if (res?.data?.getTechnicianList?.userList) {
          setClientEmployees(res.data.getTechnicianList.userList);
        }
      });
    }
  }, [props?.client, props?.site]);

  // const {
  //   loading: employeeLoading,
  //   data: allEmployees,
  //   error
  // } = useQuery(GET_ALL_EMPLOYEES, { client: AccountClient });

  const togglePopoverActive = useCallback(
    () => setPopoverActive((val) => !val),
    []
  );

  // if (employeeLoading) return <div>Loading ...</div>;

  const handleDelete = () => {
    if (props.projectId) {
      softDeleteProject({ variables: { ids: [props.projectId] } }).then(
        (res) => {
          tabContext.closeTab();
          actionToast('info', 'toast.projects.softdelete.success', {
            title: 'project.view.undo.button',
            action: () => {
              handleRestore(props.projectId);
              tabContext.openTab({
                module: ALL_MODULES.projectDetail,
                data: {
                  projectId: props.projectId,
                  title: props.title
                }
              });
            }
          });
        }
      );
    }
    // TicketClient.mutate({
    //   mutation: DELETE_PROJECT,
    //   variables: { projectId: props.projectId }
    // }).then((res) => {
    //   if (res?.data?.deleteProject) {
    //     toast('success', 'Project deleted successfully');
    //   }
    //   tabContext.closeTab();
    //   tabContext.openTab({
    //     module: 'WORKSPACE',
    //     id: 'workspace'
    //   });
    // });
  };

  const handleMembers = (membersArr) => {
    if (!membersArr?.length) return;
    const membersList = membersArr.map((member) => {
      const { label, value, name, id, ...rest } = member;
      return rest;
    });
    props.handleUpdate('addMembers', membersList);
  };

  const handleTaskAddition = (type, task) => {
    const taskObj = constructTaskObject(task);
    TicketClient.mutate({
      mutation: CREATE_MILESTONE_TASK,
      variables: {
        ...taskObj,
        project: {
          projectId: props.projectId
        }
      }
    })
      .then((res) => {
        if (res?.data?.createTask) {
          toast('success', 'Task created successfully');
          useActivityTracker({
            event: `Project - Task created successfully`
          });

          TicketClient.query({
            query: GET_PROJECT,
            variables: { projectId: props.projectId, isItProduct },
            fetchPolicy: 'network-only'
          }).then((resp) => {
            if (resp?.data?.getProject) {
              props.setProject(resp.data.getProject);
              setSheetActive(!sheetActive);
            }
          });
        }
      })
      .catch((err) => {
        // if (err?.graphQLErrors?.[0]?.extensions?.clientError?.[0]?.errorCode) {
        //   toast(
        //     'error',
        //     <FormattedMessage
        //       id={
        //         ERROR_CODES[
        //           err.graphQLErrors[0].extensions.clientError[0].errorCode
        //         ]
        //       }
        //     />
        //   );
        // } else {
        //   // toast('error', 'Something went wrong');
        // }
      });
  };

  const activator = (
    <Button
      onClick={togglePopoverActive}
      icon={<SVGIcon name="Actions" />}
      disclosure
    >
      <FormattedMessage id="project.details.actionBtn" />
    </Button>
  );
  return (
    <>
      <Popover
        active={popoverActive}
        activator={activator}
        onClose={togglePopoverActive}
      >
        <Field>
          <AccessControl
            reference={projectContext.features}
            roleToCheck="task.add"
            render={
              <>
                <div
                  data-qa="projectAddTask"
                  className="opt full-width flex actr"
                >
                  <Button
                    onClick={toggleSheetActive}
                    plain
                    monochrome
                    fullWidth
                    icon={<SVGIcon name="Tasks" />}
                  >
                    <FormattedMessage id="project.details.actions.addTask" />
                  </Button>
                </div>
                <AccessControl
                  reference={projectContext.features}
                  roleToCheck="taskTemplate.view"
                  render={
                    <div
                      data-qa="projectAddTaskTemplate"
                      className="opt full-width flex actr pt-5"
                    >
                      <CopyTask
                        tasksList={props?.taskTemplates?.getTaskTemplateList}
                        context={context}
                        name={getTranslatedText(
                          intl,
                          'project.details.actions.template'
                        )}
                        hideIcon
                        icon={<SVGIcon name="Tasks" />}
                        isLink
                      />
                    </div>
                  }
                />
              </>
            }
          />
          <AccessControl
            reference={projectContext.features}
            roleToCheck="projectManagementProject.edit"
            render={
              <div data-qa="projectAddEmployees" className="opt full-width">
                <EmployeesPicker
                  updateUserList={handleMembers}
                  allUsers={clientEmployees.filter(
                    (emp) => !presentMembers.includes(emp.userId)
                  )}
                  btnText={getTranslatedText(
                    intl,
                    'project.details.actions.members'
                  )}
                  icon={<SVGIcon name="TechnicianGroup" color="#323232" />}
                />
              </div>
            }
          />
          <AccessControl
            reference={projectContext.features}
            roleToCheck="milestone.add"
            render={
              <div data-qa="projectAddMilestone" className="opt full-width">
                <Button
                  ref={milestoneModal}
                  onClick={handleChange}
                  plain
                  monochrome
                  fullWidth
                  icon={<SVGIcon name="Milestone" color="#323232" />}
                >
                  <FormattedMessage id="project.details.actions.milestone" />
                </Button>
              </div>
            }
          />
          <AccessControl
            reference={projectContext.features}
            roleToCheck="projectManagementProject.delete"
            render={
              <div data-qa="deleteProject" className="opt full-width">
                <Button
                  // ref={delModal}
                  onClick={handleDelete}
                  destructive
                  plain
                  fullWidth
                  icon={<SVGIcon name="MoveTrash" color="#ED0050" />}
                >
                  <FormattedMessage id="project.details.actions.delete" />
                </Button>
              </div>
            }
          />
        </Field>
      </Popover>
      <MilestoneModal
        reference={milestoneModal}
        active={active}
        handleChange={handleChange}
        handleUpdate={props.handleUpdate}
        projectId={props?.projectId}
        taskTemplates={props?.taskTemplates}
        setProject={props?.setProject}
      />
      {/* <DeleteModal
        description={getTranslatedText(
          intl,
          'project.details.actions.delete.confirm'
        )}
        handleDeleteConfirmation={handleDelete}
        title={getTranslatedText(intl, 'project.details.actions.delete.text')}
        primaryBtn={getTranslatedText(
          intl,
          'project.details.actions.delete.primary'
        )}
        reference={delModal}
        active={delModalActive}
        handleChange={handleDelModalChange}
      /> */}
      <NewTask
        addOrUpdateTechGroup={handleTaskAddition}
        state={sheetActive}
        toggleSheetActive={toggleSheetActive}
        name={getTranslatedText(intl, 'project.details.actions.addTask')}
        hideIcon
        isLink
        noRender
        module="PROJECT_TASK"
        details={{ operation: 'CREATE', projectId: props?.projectId }}
      />
      <NormalModal
        isOpen={warningModal}
        toggleOpen={setWarningModal}
        title={getTranslatedText(
          intl,
          'project.details.actions.templateWarnings'
        )}
        primaryBtn={getTranslatedText(intl, 'common.confirm')}
        secondaryBtn={getTranslatedText(intl, 'common.cancel')}
        primaryAction={() => addTaskTemplatesHandler(taskTemplates)}
        description={getTranslatedText(intl, 'project.details.actions.desc')}
      />
    </>
  );
};

export default withRouter(injectIntl(ActionsBtn));
